import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import {Image, Table} from "semantic-ui-react";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";

export interface KoordinatenProps {
    mapViewerConfig: MapViewerConfiguration;
    coordinates: __esri.Point;
    highlightable: boolean;
    handleHighlightClick?: (e: React.MouseEvent | undefined, item: __esri.Point | null, layerNo: number) => void;
    selected?: boolean;
    title?: string;
}
@observer
export class Koordinaten extends Component<KoordinatenProps, any> {
    watchHandles: any[] = [];
    constructor(props: KoordinatenProps) {
        super(props);
        this.state = {
            selected: this.props.selected
        };
    }
    handleHighlightClick(e: React.MouseEvent, item: __esri.Point): void {
        if (this.state.selected){
            if (this.props.handleHighlightClick) {
                this.props.handleHighlightClick(e, null, 2);
            }
            this.setState({selected: false});
        } else {
            if (this.props.handleHighlightClick) {
                this.props.handleHighlightClick(e, item, 2);
            }
            this.setState({selected: true});
        }
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    render(): React.ReactElement | null {
        const { coordinates, highlightable, mapViewerConfig } = this.props;
        const { selected } = this.state;
        if (coordinates === null){
            return null;
        }
        let title: string;
        if (this.props.title) {
            title = this.props.title;
        } else {
            title = "Koordinaten";
        }
        const coords =
            "E " +
            new Intl.NumberFormat("de-CH").format(Math.round(coordinates.x)) +
            " / N " +
            new Intl.NumberFormat("de-CH").format(Math.round(coordinates.y));
        return (
            <Table.Row>
                <Table.Cell>{title}</Table.Cell>
                <Table.Cell>{highlightable? (
                    <div className={"geo-coords geo-highlightable"
                    + (selected? " highlighted": "")}
                    onClick={(event: React.MouseEvent) => this.handleHighlightClick(event, coordinates)}>
                        <Image src={mapViewerConfig?.pointerSymbols?.coords.url}
                            height="24" /> {coords}
                    </div>
                ):(
                    <div className={"geo-coords"}>
                        <Image src={mapViewerConfig?.pointerSymbols?.coords.url}
                            height="24" /> {coords}
                    </div>
                )}
                </Table.Cell>
            </Table.Row>
        );
    }
}
